import {Component, Input, OnInit} from '@angular/core';
import {UserService} from "../../../services/user";
import {User} from "../../../classes/user";
import {NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";
import {mergeMap, tap} from "rxjs/operators";
import {HttpErrorResponse} from "@angular/common/http";
import {InspectionOrderService} from "../../../services/inspectionOrder";
import {Inspection} from "../../../classes/inspection";
import {InspectionOrder} from "../../../classes/inspectionOrder";

@Component({
    selector: 'app-inspection-assign-modal',
    templateUrl: './inspection-assign-modal.component.html',
    styleUrls: ['./inspection-assign-modal.component.css']
})
export class InspectionAssignModalComponent implements OnInit {

    @Input() public inspection!: Inspection;
    inspectionOrders: Array<InspectionOrder> = [];
    userInspectors: Array<User> = [];
    idInspectorToAssign = '';

    constructor(public activeModal: NgbActiveModal,
                private inspectionOrderService: InspectionOrderService,
                private userService: UserService) {
    }

    ngOnInit(): void {
        this.inspectionOrderService.getByIDInspection(this.inspection.id_inspection!.toString())
            .subscribe({
                next: (inspectionOrders: any) => {
                    this.inspectionOrders = inspectionOrders;
                },
                error: (err: HttpErrorResponse) => {
                    console.log(err);
                }
            });

        this.userService.getAllByIDRole("3")
            .subscribe({
                next: (userInspectors: any) => {
                    this.userInspectors = userInspectors;
                },
                error: e => {
                    console.log('Error: ' + e);
                }
            });
    }

    passBack() {
        this.activeModal.close(this.userInspectors.find((user: User) => user.id_user === parseInt(this.idInspectorToAssign)));
    }

}
